import { render, staticRenderFns } from "./Mouse.vue?vue&type=template&id=643d5499&scoped=true&"
import script from "./Mouse.vue?vue&type=script&lang=ts&"
export * from "./Mouse.vue?vue&type=script&lang=ts&"
import style0 from "./Mouse.vue?vue&type=style&index=0&id=643d5499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643d5499",
  null
  
)

export default component.exports